





























import { AppModule } from '@app/componentlib/src/store/modules/app'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component<Typeahead>({
  props: {
    typeaheadList: Array,
    isActive: Boolean,
    title: String,
    sliceNumber: Number,
    typeaheadType: Number,
    buttonText: String,
  },
})

export default class Typeahead extends Vue {
  /**
   * Props variables
   */
  typeaheadList!: any[]
  isActive!: boolean
  title!: string
  sliceNumber!: number
  typeaheadType!: number
  buttonText: string | undefined

  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */
  mounted() {
    window.addEventListener('keydown', (e) => {
      if (e.key === "Enter" && this.isActive) {
        this.onEnterPressed()
      }
    })
    // Add event listener to close the typeahead when the user clicks outside of the component
    document.addEventListener('click', this.closeTypeaheadOnClickOutside)
  }

  unmounted() {
     // Remove event listener when the typeahead is unmounted
    document.removeEventListener('click', this.closeTypeaheadOnClickOutside)
  }

  /**
   * Getters
   */

   get isMobile (): boolean {
    return AppModule.isMobile
   }

  /**
   * Methods
   */
  emitClickedItem(item: any) {
    this.$emit("emitClickedItem", item)
  }

  away() {
    this.$emit('closeTypeahead', false)
    this.isActive = false
  }

  onEnterPressed() {
    this.$emit('onEnterPressed')
  }

  splitString(newString: string): string[] {
    if (newString !== undefined) {
      const temp = newString.split('$')
      return temp
    }

    return []
  }

  closeTypeaheadOnClickOutside(event: MouseEvent) {
    const typeheadElement = this.$refs.typeahead as HTMLElement

    if (typeheadElement !== undefined && !typeheadElement.contains(event.target as Node))
      this.isActive = false;
  }
}
